<template>
  <div class="gamma-shield-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$High Frequency photons (E = hν)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>穿透深度</label>
            <span class="val">纸/铝 已穿透</span>
          </div>
          <div class="hud-item orange">
            <label>所需屏蔽层</label>
            <span class="val">10cm+ 铅板</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 背景物体: 纸和铝片 (仅作参照，演示被穿透) -->
          <line x1="120" y1="40" x2="120" y2="200" stroke="#f8fafc" stroke-width="2" opacity="0.3" />
          <text x="120" y="215" text-anchor="middle" fill="#64748b" font-size="9">纸</text>
          
          <line x1="200" y1="40" x2="200" y2="200" stroke="#94a3b8" stroke-width="4" opacity="0.5" />
          <text x="200" y="215" text-anchor="middle" fill="#94a3b8" font-size="9">铝片</text>

          <!-- 核心屏蔽层: 铅 (Lead Block) -->
          <rect x="300" y="40" width="40" height="160" fill="#1e293b" stroke="#334155" />
          <text x="320" y="215" text-anchor="middle" fill="#94a3b8" font-size="10" font-weight="900">铅板 (Lead)</text>

          <!-- Gamma 射线路径 (高频波动波形演示) -->
          <path v-for="w in waves" :key="w.id" :d="generateWave(w)" fill="none" stroke="#fbbf24" stroke-width="1.5" opacity="0.8" />
          <circle v-for="w in waves" :key="'dot'+w.id" :cx="w.x" :cy="w.y" r="2" fill="#fff" />
        </svg>

        <div class="physics-caption">
           规律：Gamma 射线由于不带电且波长极短，穿透性极强，只有厚重的重金属才能减弱它。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节伽马光子能量 (决定穿透纵深)：{{ energy }} keV</label>
                 <el-slider v-model="energy" :min="100" :max="1000" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="primary" size="small" @click="emit">发射 Gamma 光子群</el-button>
                 <el-button size="small" @click="reset">清空路径数据</el-button>
              </div>
           </div>
        </div>
        
        <!-- 文字对比度高亮加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-view"></i></div>
           <div class="text-content">
             <p><strong>实战物理：</strong>Gamma 射线是光的极限形式。<strong>解惑：</strong>不同于 Alpha 和 Beta 粒子，它没有质量和电荷。<strong>观察：</strong>你会发现哪怕面对铝板，它也如履平地（只有微弱减弱）。这就是为何**核废水储存、工业探伤、放疗**必须依赖密闭的铅合金或数米厚混凝土。安全不仅是距离，更是高质量原子序数的阻隔。</p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'GammaRayShieldingViz',
  data() {
    return {
      energy: 511,
      waves: [],
      nextId: 0
    }
  },
  methods: {
    emit() {
       for(let i=0; i<5; i++) {
          this.waves.push({ id: this.nextId++, x: 40, y: 120 + (Math.random()-0.5)*100, isStopped: false, time: 0 });
       }
       this.animate();
    },
    generateWave(w) {
       let d = `M ${w.x-40},${w.y} `;
       for(let x=0; x<40; x+=2) {
          d += `L ${w.x-40+x},${w.y + Math.sin(x*0.8)*5}`;
       }
       return d;
    },
    animate() {
       this.waves.forEach(w => {
          if(!w.isStopped) {
             w.x += 4;
             if (w.x > 300 && Math.random() < 0.1) { // Probability of absorption in lead
                w.isStopped = true;
             }
             if (w.x > 450) w.isStopped = true;
          }
       });
       if (this.waves.some(w => !w.isStopped)) {
          requestAnimationFrame(this.animate);
       }
    },
    reset() { this.waves = []; }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.gamma-shield-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
